import { Flex } from '@chakra-ui/react';
import { FC } from 'react';

import { useTrackOptions } from '@/components/ui/features/lecture/LecturePlayer/LecturePlayer.hooks';
import { VideoJS } from '@/components/ui/shared/video/VideoJS/VideoJS';
import { defaultVideoType } from '@/constants/video';
import { useLibLynx } from '@/hooks/useLibLynx';
import { Transcript } from '@/resources/Transcript';
import { ILibLynxMetadata } from '@/types/LibLynx';
import { IPlayerAnalyticsResource, IVideoEventAnalytics } from '@/utils/analytics';

interface IVideoContent {
  title: string;
  analytics: IVideoEventAnalytics | IPlayerAnalyticsResource;
  poster: string;
  source: string;
  transcripts?: Array<Transcript>;
}

export const VideoContent: FC<IVideoContent> = ({ title, analytics, poster, source, transcripts }) => {
  const trackOptions = useTrackOptions({ transcripts, activeTrackId: null });
  const libLynx = useLibLynx();
  const onPlay = () => {
    const { event_name, event_id } = analytics as IVideoEventAnalytics;
    const libLynxMetadata: ILibLynxMetadata = { dtype: 'multimedia', id: event_id, title: event_name };

    libLynx.send('trackItemRequest', { im: libLynxMetadata });
  };

  return (
    <Flex w="full" h="full" justifyContent="center" bgColor="black" alignItems="center">
      <VideoJS
        data-peer
        title={title}
        options={{
          sources: [{ src: source, type: defaultVideoType }],
          tracks: trackOptions,
          poster: poster,
        }}
        crossOrigin="anonymous"
        onPlay={onPlay}
      ></VideoJS>
    </Flex>
  );
};
